import type { SubitemKind } from './subitem-eligibility';
import { toUtcDate } from './office-time';

// Legacy `subitemButtons.getIconColor` parity: an add-button is tinted by the
// status of the existing same-type sub-item — by its operation status code and
// how many days until it starts. Returns null when there's no signal.
export type SubitemButtonColor = 'blue' | 'amber' | 'red' | 'green';

const daysUntil = (startTime: string | null): number => {
  if (!startTime) return 0;
  const now = Date.now();
  const start = toUtcDate(startTime).getTime();
  return Math.ceil((start - now) / (1000 * 60 * 60 * 24));
};

// `daysDiff`-based escalation used by the S1 / ticket-default branches.
const byProximity = (days: number): SubitemButtonColor => {
  if (days > 7) return 'blue';
  if (days > 3) return 'amber';
  return 'red';
};

export const subitemButtonColor = (
  kind: SubitemKind,
  statusCode: string | null,
  startTime: string | null
): SubitemButtonColor => {
  const code = statusCode ?? '';
  const days = daysUntil(startTime);

  if (kind === 'ticket') {
    if (['S7', 'S90', 'S91'].includes(code)) return 'green';
    return byProximity(days);
  }

  // Transport / Guide / Other.
  if (['S20', 'S80', 'S81'].includes(code)) return 'red';
  if (code === 'S1') return byProximity(days);
  if (code === 'S2') return days <= 3 ? 'red' : 'amber';
  if (['S3', 'S4'].includes(code)) return 'amber';
  if (['S5', 'S6', 'S7', 'S90', 'S91'].includes(code)) return 'green';
  const num = Number.parseInt(code.replace('S', ''), 10);
  if (!Number.isNaN(num) && num >= 5) return 'green';
  return 'amber';
};
